module.exports = __webpack_public_path__ + "img/40_5.51ca5922.png";